import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import Dropzone from 'react-dropzone';
import fileDownload from 'react-file-download';

import Alert from 'components/ui/Alert';
import { uploadBulkConsigneeCSVFile } from 'utils/UserWebAPIUtils';
import { useTranslation, withTranslation } from 'react-i18next';
import FormCard from '../../v2/FormCard';
import CargomaticInput from '../../v2/input';
import UserActionCreators from '../../../actions/UserActionCreators';
import PhoneField from 'components/v2/forms/PhoneField';

const consigneeTemplate = 'company_name,first_name,last_name,email,phone\n,,,,';

const getEmptyState = () => {
  return {
    creatingConsignees: false,
    showInvalidFileType: false,
    consignee: {
      company_name: '',
      email: '',
      first_name: '',
      last_name: '',
      password: '',
      phone: '',
    },
  };
};

const ORComponent = () => {
  const { t } = useTranslation();
  return (
    <div className="flex">
      <div className="w-1/2 border-b border-solid">&nbsp;</div>
      <div className="px-2 m-0 -mb-7 align-bottom">
        <h4 className="text-lg font-medium text-gray-700 leading-6">
          {t('OR')}
        </h4>
      </div>
      <div className="w-1/2 border-b border-solid">&nbsp;</div>
    </div>
  );
};

class RegisterConsignee extends Component {
  constructor(props) {
    super(props);
    this.state = getEmptyState();
  }

  handleChange = (field) => (value) => {
    this.setState((prevState) => {
      return {
        consignee: {
          ...prevState.consignee,
          [field]: value,
        },
      };
    });
  };

  handleRegister = (e) => {
    e.preventDefault();
    const { consignee } = this.state;
    UserActionCreators.addConsignee({
      ...consignee,
    });
    this.setState(getEmptyState());
  };

  onFileDrop = (files) => {
    if (!files || !files.length) {
      return this.setState({ showInvalidFileType: true });
    }

    this.setState(
      { creatingConsignees: true, showInvalidFileType: false },
      async () => {
        await uploadBulkConsigneeCSVFile(files[0]).catch((e) => {
          console.log('Error', e);
        });
        this.setState({ creatingConsignees: false });
      },
    );
  };

  render() {
    const { consignee, showInvalidFileType, creatingConsignees } = this.state;
    const { t } = this.props;
    const disabled =
      isEmpty(consignee.company_name) ||
      isEmpty(consignee.email) ||
      isEmpty(consignee.first_name) ||
      isEmpty(consignee.last_name) ||
      isEmpty(consignee.password) ||
      isEmpty(consignee.phone);

    return (
      <FormCard
        actions={() => (
          <button
            disabled={disabled}
            className="button button-green"
            type="submit"
            onClick={this.handleRegister}
          >
            {t('REGISTER_CONSIGNEE')}
          </button>
        )}
      >
        <div>
          <h3 className="text-lg font-medium text-gray-900 leading-6">
            {t('CONSIGNEE_REGISTRATION')}
            <span
              className="text-green px-1 cursor-pointer"
              onClick={() =>
                fileDownload(consigneeTemplate, 'consignee-template.csv')
              }
            >
              <i className="fa fa-download" />
            </span>
          </h3>
          <Dropzone
            className="w-full h-24 border border-green border-6 border-dashed rounded p-4"
            onDrop={this.onFileDrop}
            accept="text/csv"
            multiple={false}
          >
            {!creatingConsignees && !showInvalidFileType && (
              <label className="form-label">
                {t('CLICK_OR_DRAG_TO_UPLOAD_FILE')}
              </label>
            )}
            {showInvalidFileType && (
              <Alert type="error">{t('INVALID_FILE_TYPE_UPLOAD_CSV')}</Alert>
            )}
            {creatingConsignees && (
              <span>
                {t('PROCESSING_CONSIGNEES')}
                <i className="fa fa-spinner fa-spin text-green px-2" />
              </span>
            )}
          </Dropzone>
        </div>
        <div className="py-2">
          <ORComponent />
        </div>
        <div className="mb-4">
          <h3 className="text-lg font-medium text-gray-900 leading-6">
            {t('CREATE_CONSIGNEE')}
          </h3>
        </div>
        <div className="grid grid-cols-4 gap-6">
          <div className="col-span-4 sm:col-span-2">
            <CargomaticInput
              className="mb-4"
              type="text"
              value={consignee.first_name}
              label={t('FIRST_NAME')}
              placeholder={t('FIRST_NAME')}
              onChange={this.handleChange('first_name')}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <CargomaticInput
              className="mb-4"
              type="text"
              value={consignee.last_name}
              label={t('LAST_NAME')}
              placeholder={t('LAST_NAME')}
              onChange={this.handleChange('last_name')}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <CargomaticInput
              className="mb-4"
              type="text"
              value={consignee.company_name}
              label={t('COMPANY_NAME')}
              placeholder={t('COMPANY_NAME')}
              onChange={this.handleChange('company_name')}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <CargomaticInput
              className="mb-4"
              type="phone"
              value={consignee.phone}
              label={t('PHONE')}
              placeholder={t('PHONE')}
              onChange={this.handleChange('phone')}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <CargomaticInput
              className="mb-4"
              type="email"
              value={consignee.email}
              label={t('EMAIL')}
              placeholder={t('EMAIL')}
              onChange={this.handleChange('email')}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <CargomaticInput
              className="mb-4"
              type="password"
              placeholder={t('PASSWORD')}
              value={consignee.password}
              label={t('PASSWORD')}
              onChange={this.handleChange('password')}
            />
          </div>
        </div>
      </FormCard>
    );
  }
}

export default withTranslation()(RegisterConsignee);
